export interface ApplicationLinkProps {
    arg01?: string;
    arg02?: string;
    arg03?: string;
    arg04?: string;
    arg05?: string;
    arg06?: string;
    arg07?: string;
    arg08?: string;
    arg09?: string;
    arg10?: string;
    arg11?: string;
    arg12?: string;
}

function makeLinkPart(name: string, value?: string): string {
    if (value) {
        return `${name}=${value}`;
    }
}

export const makeApplicationLink = (props: ApplicationLinkProps): string => {
    const linkParts: string[] = [];

    linkParts.push(makeLinkPart("arg01", props.arg01));
    linkParts.push(makeLinkPart("arg02", props.arg02));
    linkParts.push(makeLinkPart("arg03", props.arg03));
    linkParts.push(makeLinkPart("arg04", props.arg04));
    linkParts.push(makeLinkPart("arg05", props.arg05));
    linkParts.push(makeLinkPart("arg06", props.arg06));
    linkParts.push(makeLinkPart("arg07", props.arg07));
    linkParts.push(makeLinkPart("arg08", props.arg08));
    linkParts.push(makeLinkPart("arg09", props.arg09));
    linkParts.push(makeLinkPart("arg10", props.arg10));
    linkParts.push(makeLinkPart("arg11", props.arg11));
    linkParts.push(makeLinkPart("arg12", props.arg12));

    return "?" + linkParts.filter(x => x).join("&");
};

export const navigateToApplicationLink = (props: ApplicationLinkProps): void => {
    const link = makeApplicationLink(props);
    window.location.href = link;
};
